import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestArticles from './components/LatestArticles';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import SchemaInjector from '@/components/base/SchemaInjector';
import { getOrganizationSchema, getWebSiteSchema, getWebPageSchema } from '@/mocks/schema';

export default function Home() {
  const schemas = [
    getOrganizationSchema(),
    getWebSiteSchema(),
    getWebPageSchema({
      title: '韩漫之家 - 韩国漫画免费阅读 | 韩漫在线 | 韩漫大全',
      description: '韩漫之家提供免费阅读韩国漫画的服务，包括韩漫在线和韩漫大全，让您轻松访问海量韩漫资源，享受流畅的阅读乐趣。',
      url: 'http://informyi.com/',
    }),
  ];

  return (
    <>
      <SchemaInjector schema={schemas} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotRecommend />
        <LatestArticles />
        <Testimonials />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}